var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderLogoMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__a",
    x1: -2.875,
    y1: -2.61,
    x2: 1.118,
    y2: 1.071,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0081b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e63471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#fdcb1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__b",
    x1: -2.06,
    y1: -1.861,
    x2: 1.932,
    y2: 1.82,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__c",
    x1: -0.44,
    y1: -0.362,
    x2: 3.553,
    y2: 3.319,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__d",
    x1: 0.375,
    y1: 0.388,
    x2: 4.367,
    y2: 4.068,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__e",
    x1: -1.075,
    y1: -0.713,
    x2: 0.699,
    y2: 0.655,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__f",
    x1: -1.182,
    y1: -0.856,
    x2: 1.319,
    y2: 1.16,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__g",
    x1: -0.347,
    y1: -0.226,
    x2: 2.904,
    y2: 2.563,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__h",
    x1: -1.327,
    y1: -1.181,
    x2: 2.666,
    y2: 2.5,
    xlinkHref: "#header_logo_mobile_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header_logo_mobile_svg__i",
    x1: -0.667,
    y1: -0.436,
    x2: 1.724,
    y2: 1.481,
    xlinkHref: "#header_logo_mobile_svg__a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.484 53.094a2.906 2.906 0 11-3.09 2.71 2.888 2.888 0 013.09-2.71z",
    transform: "translate(-72.8 -34.079)",
    fill: "url(#header_logo_mobile_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.084 53.094a2.906 2.906 0 11-3.09 2.71 2.946 2.946 0 013.09-2.71z",
    transform: "translate(-63.147 -34.079)",
    fill: "url(#header_logo_mobile_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.384 53.094a2.906 2.906 0 11-3.09 2.71 2.888 2.888 0 013.09-2.71z",
    transform: "translate(-43.894 -34.079)",
    fill: "url(#header_logo_mobile_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.984 53.094a2.906 2.906 0 11-3.09 2.71 2.888 2.888 0 013.09-2.71z",
    transform: "translate(-34.241 -34.079)",
    fill: "url(#header_logo_mobile_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.617 79.541a2.666 2.666 0 01-.523-3.756l7.7-10.268a2.666 2.666 0 013.756-.523 2.666 2.666 0 01.523 3.756l-7.7 10.268a2.709 2.709 0 01-3.756.523z",
    transform: "translate(-60.292 -40.037)",
    fill: "url(#header_logo_mobile_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.117 74.5a2.666 2.666 0 01-.523-3.756l3.9-5.229a2.666 2.666 0 013.756-.523 2.666 2.666 0 01.523 3.756l-3.9 5.229a2.666 2.666 0 01-3.756.523z",
    transform: "translate(-54.783 -40.037)",
    fill: "url(#header_logo_mobile_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.917 71.7a2.666 2.666 0 01-.523-3.756l1.759-2.329a2.666 2.666 0 013.756-.523 2.666 2.666 0 01.523 3.755l-1.759 2.282a2.724 2.724 0 01-3.756.571z",
    transform: "translate(-37.891 -40.089)",
    fill: "url(#header_logo_mobile_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.784 62.494a2.906 2.906 0 11-3.09 2.71 2.888 2.888 0 013.09-2.71z",
    transform: "translate(-49.874 -39.01)",
    fill: "url(#header_logo_mobile_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.817 84.473a2.666 2.666 0 01-.523-3.756l4.326-5.8a2.666 2.666 0 013.756-.523 2.666 2.666 0 01.524 3.756l-4.326 5.8a2.709 2.709 0 01-3.757.523z",
    transform: "translate(-40.986 -44.968)",
    fill: "url(#header_logo_mobile_svg__i)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderLogoMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/header_logo_mobile.af79edcd59abf1bc02bf7cc6d9764b39.svg";